import { SavedSearch, SearchRegion } from "../../../types/neighborhoodSearch";
import { LeadList } from "../../../libs/landvoice-api/client/api";

/**
 * Converts a LeadList to a SavedSearch
 * @param leadList - The lead list to convert
 * @returns The converted saved search
 */
export const convertLeadListToSavedSearch = (leadList: LeadList): SavedSearch => ({
  id: leadList.id || "",
  name: leadList.name || "",
  create_timestamp: leadList.create_timestamp || "",
  hidden: leadList.hidden || false,
  search_parameters: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    searchRegion: (leadList.search_parameters as any)?.searchRegion as
      | SearchRegion
      | undefined,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    searchFilters: (leadList.search_parameters as any)?.searchFilters,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    combinedSearchSources: (leadList.search_parameters as any)?.combinedSearchSources,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    searchAddress: (leadList.search_parameters as any)?.searchAddress,
  },
  result_count: leadList.result_count || 0,
  lookup_status: leadList.lookup_status || "",
});